/* Tröndle – gemeinsames Skript für alle Seiten.
   Jeder Block prüft selbst, ob seine Elemente auf der Seite vorhanden sind. */
(function () {
"use strict";
const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
const DATA = JSON.parse($("#site-data").textContent);

/* Reserve the actual mobile shortcut height, including enlarged text. */
(function () {
  const dock = $(".dock");
  if (!dock) return;
  const measure = () => {
    const height = dock.getBoundingClientRect().height;
    if (height > 0) document.documentElement.style.setProperty("--dock-height", `${height}px`);
  };
  new ResizeObserver(measure).observe(dock);
  measure();
})();

/* Connected procedure lines follow each actual grid row, including wrapped rows. */
(function () {
  const lists = $$(".process-local");
  if (!lists.length) return;
  const motion = matchMedia("(prefers-reduced-motion: reduce)");
  let procedures = [], pending = false;
  function paint() {
    pending = false;
    procedures.forEach(({ list, rows, totalWidth }) => {
      const top = list.getBoundingClientRect().top;
      const height = list.offsetHeight;
      const progress = motion.matches ? 1 : Math.max(0, Math.min(1,
        (innerHeight - top - height * .3) / (innerHeight * .55 + height * .7)));
      let remaining = progress * totalWidth;
      rows.forEach(({ segments, width }) => {
        segments.forEach(({ item, offset, length }) => {
          const fill = Math.max(0, Math.min(1, (remaining - offset) / length));
          item.style.setProperty("--process-fill", `${fill * 100}%`);
        });
        remaining -= width;
      });
    });
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(paint); } }
  function measure() {
    procedures = [];
    lists.forEach(list => {
      const grouped = [], rows = [];
      [...list.children].forEach(item => {
        const last = grouped[grouped.length - 1];
        if (last && Math.abs(last[0].offsetTop - item.offsetTop) < 2) last.push(item);
        else grouped.push([item]);
      });
      grouped.forEach(items => {
        const first = items[0], start = first.offsetLeft + 22;
        const end = items.at(-1).offsetLeft + items.at(-1).offsetWidth;
        const segments = items.map((item, index) => {
          const left = item.offsetLeft + 22;
          const right = items[index + 1] ? items[index + 1].offsetLeft + 22 : end;
          const length = Math.max(1, right - left);
          item.style.setProperty("--process-line-width", `${length}px`);
          return { item, offset: left - start, length };
        });
        rows.push({ first, segments, width: end - start, height: Math.max(...items.map(item => item.offsetHeight)) });
      });
      procedures.push({ list, rows, totalWidth: rows.reduce((sum, row) => sum + row.width, 0) });
    });
    paint();
  }
  const observer = new ResizeObserver(measure);
  lists.forEach(list => observer.observe(list));
  addEventListener("scroll", schedule, { passive: true });
  addEventListener("resize", measure);
  motion.addEventListener("change", schedule);
  document.fonts.ready.then(measure);
  measure();
})();

/* ---------- Kopf: beim Scrollen verdichten ---------- */
const mh = $("#masthead");
addEventListener("scroll", () => mh.classList.toggle("scrolled", scrollY > 40), { passive: true });

/* ---------- Sprungmarken: weich scrollen, Fernwartung kurz hervorheben ---------- */
function jump(id, smooth) {
  const t = document.getElementById(id);
  if (!t) return false;
  t.scrollIntoView({ behavior: smooth && !reduce ? "smooth" : "auto", block: id === "fernwartung" ? "center" : "start" });
  if (id === "fernwartung" && !reduce) { t.classList.remove("flash"); void t.offsetWidth; t.classList.add("flash"); }
  return true;
}
document.addEventListener("click", (e) => {
  const a = e.target.closest('a[href^="#"]');
  if (!a) return;
  const id = a.getAttribute("href").slice(1);
  if (!id) { e.preventDefault(); return; }
  if (jump(id, true)) {
    e.preventDefault();
    if (a.classList.contains("skip")) {
      const target = document.getElementById(id);
      if (!target.hasAttribute("tabindex")) target.tabIndex = -1;
      target.focus({ preventScroll: true });
    }
    try { history.replaceState(null, "", "#" + id); } catch (_) {}
  }
});
if (location.hash) requestAnimationFrame(() => jump(decodeURIComponent(location.hash.slice(1)), false));

/* ---------- Navigation: one state for visibility and assistive technology ---------- */
(function () {
  const nav = $("#nav"), burger = $("#burger");
  if (!nav || !burger) return;
  const desktop = matchMedia("(min-width: 1001px)");
  // Preserve document geometry while the open mobile header is fixed to the viewport.
  const headerSpace = document.createElement("div");
  headerSpace.hidden = true;
  headerSpace.setAttribute("aria-hidden", "true");
  if (mh) mh.before(headerSpace);
  const contact = $(".rail-kontakt");
  const items = $$(".nav-item").filter((item) => $(".sub-toggle", item));
  const sizeMobileNav = () => {
    if (desktop.matches) return;
    if (nav.classList.contains("open")) {
      nav.style.setProperty("--nav-top", `${Math.max(0, nav.getBoundingClientRect().top)}px`);
    }
    if (mh && contact?.classList.contains("open")) {
      mh.style.setProperty("--contact-top", `${$(".rail", mh).getBoundingClientRect().bottom}px`);
    }
  };
  const updateMobileHeader = (change) => {
    const wasOpen = !headerSpace.hidden;
    const pageY = window.scrollY;
    const headerHeight = mh?.getBoundingClientRect().height || 0;
    change();
    const open = !desktop.matches && (nav.classList.contains("open") || contact?.classList.contains("open"));
    if (open && headerSpace.hidden) headerSpace.style.height = `${headerHeight}px`;
    headerSpace.hidden = !open;
    sizeMobileNav();
    // Only preserve position when entering/leaving the fixed mobile overlay.
    // Otherwise an outside click would cancel an anchor's smooth scroll.
    if (wasOpen || open) window.scrollTo({ top: pageY, behavior: "instant" });
  };
  const setOpen = (item, open) => updateMobileHeader(() => {
    item.classList.toggle("open", open);
    $(".sub-toggle", item).setAttribute("aria-expanded", String(open));
  });
  const closeAll = (except) => items.forEach((item) => { if (item !== except) setOpen(item, false); });
  const openItem = (item) => {
    if (item === contact && !desktop.matches) setNavOpen(false);
    closeAll(item);
    setOpen(item, true);
  };
  const setNavOpen = (open) => {
    closeAll();
    updateMobileHeader(() => nav.classList.toggle("open", open));
    burger.setAttribute("aria-expanded", String(open));
    burger.setAttribute("aria-label", open ? "Menü schließen" : "Menü öffnen");
  };
  items.forEach((item) => {
    const toggle = $(".sub-toggle", item);
    toggle.addEventListener("click", (event) => {
      event.stopPropagation();
      if (item.classList.contains("open")) setOpen(item, false); else openItem(item);
    });
    item.addEventListener("pointerenter", (event) => {
      if (desktop.matches && event.pointerType !== "touch") openItem(item);
    });
    item.addEventListener("pointerleave", (event) => {
      // Touch pointers leave after each tap, even while the disclosure stays open.
      // On iOS the button may not receive focus, so only hover pointers may close it here.
      if (event.pointerType !== "touch" && !item.contains(document.activeElement)) setOpen(item, false);
    });
    item.addEventListener("focusin", (event) => {
      // A focused disclosure button is opened explicitly with Enter/Space.
      // Opening it on focus would make the subsequent click close it again.
      if (desktop.matches && event.target !== toggle && !item.contains(event.relatedTarget)) openItem(item);
    });
    item.addEventListener("focusout", (event) => {
      if (!item.contains(event.relatedTarget)) setOpen(item, false);
    });
  });
  burger.addEventListener("click", () => setNavOpen(!nav.classList.contains("open")));
  document.addEventListener("click", (event) => {
    if (!event.target.closest(".nav-item") && !event.target.closest("#burger")) closeAll();
  });
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    const item = document.activeElement?.closest(".nav-item");
    if (item?.classList.contains("open")) {
      event.preventDefault();
      setOpen(item, false);
      $(".sub-toggle", item).focus();
    } else if (nav.classList.contains("open")) {
      event.preventDefault();
      setNavOpen(false);
      burger.focus();
    } else closeAll();
  });
  $$("a", nav).forEach((link) => link.addEventListener("click", () => setNavOpen(false)));
  desktop.addEventListener("change", () => setNavOpen(false));
  addEventListener("resize", sizeMobileNav);
  addEventListener("scroll", sizeMobileNav, { passive: true });
  if (mh) new ResizeObserver(sizeMobileNav).observe(mh);
})();

/* ---------- Bewegung anhalten (Laufbänder, Wolken, Wortwechsel) ---------- */
let paused = reduce;
const scene = $(".sky .scene");
function setPaused(p) {
  paused = p; document.body.classList.toggle("paused", p);
  if (scene && scene.pauseAnimations) p ? scene.pauseAnimations() : scene.unpauseAnimations();
  const b = $("#motionToggle");
  if (b) { b.setAttribute("aria-pressed", p); const t = p ? "Bewegung starten" : "Bewegung anhalten"; b.title = t; b.innerHTML = `<svg class="ico" aria-hidden="true"><use href="#i-${p ? "play" : "pause"}"/></svg><span class="sr-only">${t}</span>`; }
}
if ($("#motionToggle")) $("#motionToggle").addEventListener("click", () => setPaused(!paused));
if (reduce) setPaused(true);

/* ---------- Independent, optional word lists on native text elements ---------- */
$$("[data-rotating-words]").forEach((rot) => {
  const words = Array.from(rot.children);
  if (words.length < 2) return;
  let i = 0;
  setInterval(() => {
    if (paused || document.hidden || matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const cur = words[i]; i = (i + 1) % words.length; const next = words[i];
    cur.classList.remove("on"); cur.classList.add("out");
    next.classList.remove("out"); next.classList.add("on");
    setTimeout(() => cur.classList.remove("out"), 750);
  }, 2600);
});

/* ---------- Höhe der Kopfzeile als CSS-Variable: Sprungleisten kleben ohne Spalt direkt darunter ---------- */
(function () {
  const m = $(".masthead");
  if (!m) return;
  const subnav = $(".subnav");
  const setze = () => {
    document.documentElement.style.setProperty("--kopf-h", m.getBoundingClientRect().height + "px");
    document.documentElement.style.setProperty("--sprungnav-h", (subnav?.getBoundingClientRect().height || 0) + "px");
  };
  setze();
  if ("ResizeObserver" in window) {
    const observer = new ResizeObserver(setze);
    observer.observe(m);
    if (subnav) observer.observe(subnav);
  }
})();

/* ---------- Hero: Wolken ziehen beim Scrollen leicht mit ---------- */
(function () {
  const c = $("#clouds");
  if (!c || reduce) return;
  let tick = false;
  addEventListener("scroll", () => {
    if (tick) return; tick = true;
    requestAnimationFrame(() => { c.style.transform = `translateY(${Math.min(scrollY, 900) * -0.12}px)`; tick = false; });
  }, { passive: true });
})();

/* ---------- Live-Status hegau.cloud (Instatus) ---------- */
// Letzter Stand der Statusseite; der Assistent nutzt ihn bei Meldungen zur hegau.cloud
const RZ = { summary: null, zeit: 0 };
const RZ_TAKT = 5 * 60 * 1000; // alle 5 Minuten
function rzStatus(maxAlter) {
  if (RZ.summary && Date.now() - RZ.zeit < maxAlter) return Promise.resolve(RZ.summary);
  const ctl = new AbortController(); const t = setTimeout(() => ctl.abort(), 6000);
  return fetch(DATA.links.statusSummary, { cache: "no-store", signal: ctl.signal }).then((r) => { clearTimeout(t); if (!r.ok) throw new Error(r.status); return r.json(); })
    .then((j) => { RZ.summary = j; RZ.zeit = Date.now(); return j; });
}
(function () {
  const pill = $("#rzPill"), hero = $("#rzHero"), groups = $("#rzGroups");
  if (!pill && !hero) return;
  const L = DATA.links;
  const TXT = {
    UP: ["up", "hegau.cloud: alle Systeme verfügbar", "Alle Systeme verfügbar", "Alles läuft. Verlauf und geplante Wartungen auf status.hegau.cloud."],
    HASISSUES: ["issue", "hegau.cloud: Störung, Details ansehen", "Es gibt eine Störung", "Wir arbeiten daran. Details und Verlauf auf status.hegau.cloud."],
    UNDERMAINTENANCE: ["maint", "hegau.cloud: Wartungsarbeiten", "Wartungsarbeiten laufen", "Geplante Arbeiten. Details auf status.hegau.cloud."]
  };
  const KOMP = { OPERATIONAL: ["up", "Betriebsbereit"], UNDERMAINTENANCE: ["maint", "Wartung"], DEGRADEDPERFORMANCE: ["issue", "Eingeschränkt"], PARTIALOUTAGE: ["issue", "Teilausfall"], MAJOROUTAGE: ["down", "Ausfall"] };
  const RANK = { up: 0, maint: 1, issue: 2, down: 3, unknown: 1 };
  const get = (url) => {
    const ctl = new AbortController(); const t = setTimeout(() => ctl.abort(), 6000);
    return fetch(url, { cache: "no-store", signal: ctl.signal }).then((r) => { clearTimeout(t); if (!r.ok) throw new Error(r.status); return r.json(); });
  };
  function show(state, long, title, text) {
    if (pill) { pill.dataset.state = state; $(".rz-long", pill).textContent = long; }
    if (hero) { hero.dataset.state = state; $("#rzHeroTitle").textContent = title; $("#rzHeroText").textContent = text; }
  }
  function render(comp) {
    if (!groups) return;
    const by = {};
    comp.components.forEach((c) => { if (!c.group) return; (by[c.group.name] = by[c.group.name] || []).push(c); });
    const names = Object.keys(by).sort((a, b) => a.localeCompare(b, "de"));
    groups.innerHTML = names.map((g) => {
      const items = by[g].map((c) => { const k = KOMP[c.status] || ["unknown", c.status]; return { n: c.name, k }; });
      const worst = items.reduce((w, i) => RANK[i.k[0]] > RANK[w[0]] ? i.k : w, ["up", "Betriebsbereit"]);
      return `<details class="rz-group" data-state="${worst[0]}"><summary><i class="led" aria-hidden="true"></i><b>${esc(g)}</b><span>${worst[1]} · ${items.length} Komponente${items.length > 1 ? "n" : ""}</span></summary><ul>${items.map((i) => `<li data-state="${i.k[0]}"><i class="led" aria-hidden="true"></i><span>${esc(i.n)}</span><em>${i.k[1]}</em></li>`).join("")}</ul></details>`;
    }).join("");
    const stamp = $("#rzStamp"); if (stamp) stamp.textContent = "Stand: " + new Date().toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" }) + " Uhr, aktualisiert sich alle 5 Minuten.";
  }
  function load() {
    if (document.hidden) return;
    rzStatus(RZ_TAKT - 5000).then((s) => {
      const st = s && s.page && s.page.status, t = TXT[st];
      if (t) show(t[0], t[1], t[2], t[3]); else show("unknown", "hegau.cloud: Status ansehen", "Status ansehen", "Aktueller Stand auf status.hegau.cloud.");
    }).catch(() => show("unknown", "hegau.cloud: Status ansehen", "Status konnte nicht geladen werden", "Bitte direkt auf status.hegau.cloud nachsehen."));
    if (groups) get(L.statusComponents).then(render).catch(() => { groups.innerHTML = ""; });
  }
  load();
  setInterval(load, RZ_TAKT);
  // Beim Zurückkehren in den Tab nur nachladen, wenn der letzte Stand älter als 5 Minuten ist
  document.addEventListener("visibilitychange", () => { if (!document.hidden && Date.now() - RZ.zeit >= RZ_TAKT) load(); });
})();

/* ---------- Interview-Videos: erst beim Klick laden ---------- */
$$(".vid-frame").forEach((f) => {
  $(".vid-play", f).addEventListener("click", () => {
    $$(".vid-frame video").forEach((v) => v.pause());
    const v = document.createElement("video");
    v.src = f.dataset.src; v.controls = true; v.playsInline = true; v.autoplay = true; v.preload = "auto";
    v.setAttribute("aria-label", f.dataset.titel);
    v.tabIndex = 0;
    if (f.dataset.captions) {
      const track = document.createElement("track");
      track.kind = "captions";
      track.src = f.dataset.captions;
      track.srclang = "de";
      track.label = "Deutsch";
      v.appendChild(track);
    }
    f.replaceChildren(v);
    v.focus();
  });
});

/* ---------- Bildbetrachter (Geschichte) ---------- */
(function () {
  const lb = $("#lightbox");
  if (!lb) return;
  let zurueck = null;
  $$("[data-gross]").forEach((b) => b.addEventListener("click", () => {
    zurueck = b;
    $("img", lb).src = b.dataset.gross; $("img", lb).alt = b.dataset.alt; $("p", lb).textContent = b.dataset.alt;
    lb.showModal();
  }));
  $(".lb-zu", lb).addEventListener("click", () => lb.close());
  lb.addEventListener("click", (e) => { if (e.target === lb) lb.close(); });
  lb.addEventListener("close", () => { if (zurueck) zurueck.focus(); });
})();

/* ---------- Datenblatt-Betrachter (Lösungen aus DocuCraft) ---------- */
(function () {
  const dlg = $("#blattDialog");
  if (!dlg) return;
  let zurueck = null;
  const oeffnen = (quelle, ausloeser) => {
    let b; try { b = JSON.parse(quelle.dataset.blatt); } catch { return; }
    zurueck = ausloeser;
    $("#blattTitel").textContent = b.titel;
    $("#blattMeta").textContent = `${b.seitenzahl} ${b.seitenzahl === 1 ? "Seite" : "Seiten"} · Stand ${b.stand}`;
    $("#blattPdf").href = b.pdf;
    $("#blattSeiten").innerHTML = b.seiten.map((src, i) => `<img src="${src}" alt="Seite ${i + 1} von ${b.seiten.length}: ${esc(b.titel)}" loading="lazy">`).join("");
    $("#blattSeiten").scrollTop = 0;
    dlg.showModal();
  };
  document.addEventListener("click", (e) => {
    const v = e.target.closest("[data-blatt]");
    const k = e.target.closest("[data-blatt-oeffnen]");
    if (v) oeffnen(v, v);
    else if (k) { const q = $("[data-blatt]", k.closest(".ls-karte")); if (q) oeffnen(q, k); }
  });
  $(".bd-zu", dlg).addEventListener("click", () => dlg.close());
  dlg.addEventListener("click", (e) => { if (e.target === dlg) dlg.close(); });
  dlg.addEventListener("close", () => { if (zurueck) zurueck.focus(); });
})();

/* ---------- Fernwartung: Dialog mit Hinweis und Programmen (wie die Terminbuchung) ---------- */
(function () {
  const dlg = $("#fwDialog");
  if (!dlg) return;
  let zurueck = null;
  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-fernwartung]");
    if (!b) return;
    zurueck = b;
    if ($("#drawer").classList.contains("on")) closeAssistant();
    dlg.showModal();
  });
  $(".td-zu", dlg).addEventListener("click", () => dlg.close());
  dlg.addEventListener("click", (e) => { if (e.target === dlg) dlg.close(); });
  dlg.addEventListener("close", () => { if (zurueck && zurueck.isConnected) zurueck.focus(); });
})();

/* ---------- Terminbuchung (Zeeg) im Popover ---------- */
const terminDlg = $("#terminDialog");
let terminZurueck = null;
function openTermin(id) {
  // Eigener Buchungslink (z. B. eines Ansprechpartners): kein Eintrag in site.termine, dann neutral „Termin buchen“
  const t = DATA.termine.find((x) => x.id === id || x.url === id) || (String(id || "").startsWith("https://zeeg.me/") ? { id: "", titel: "Termin buchen", dauer: "", text: "", url: id } : DATA.termine[0]);
  terminZurueck = document.activeElement;
  $("#terminTitel").textContent = t.dauer ? t.titel + " · " + t.dauer : t.titel;
  $("#terminText").textContent = t.text;
  $("#terminExtern").href = t.url;
  $$(".td-art", terminDlg).forEach((b) => b.setAttribute("aria-pressed", b.dataset.terminId === t.id));
  const f = $("#terminFrame");
  if (f.getAttribute("src") !== t.url) f.src = t.url;
  if (!terminDlg.open) terminDlg.showModal();
}
if (terminDlg) {
  $(".td-zu", terminDlg).addEventListener("click", () => terminDlg.close());
  terminDlg.addEventListener("click", (e) => { if (e.target === terminDlg) terminDlg.close(); });
  terminDlg.addEventListener("close", () => { if (terminZurueck && terminZurueck.isConnected) terminZurueck.focus(); });
  $$(".td-art", terminDlg).forEach((b) => b.addEventListener("click", () => openTermin(b.dataset.terminId)));
  // Alle Terminlinks (zeeg.me) und Knöpfe mit data-termin-open öffnen das Popover
  document.addEventListener("click", (e) => {
    const a = e.target.closest('a[href*="zeeg.me/"], [data-termin-open]');
    if (!a || a.closest("#terminDialog")) return;
    e.preventDefault();
    if ($("#drawer").classList.contains("on")) closeAssistant();
    openTermin(a.dataset.terminOpen || a.getAttribute("href"));
  });
}

/* ---------- Zahlen hochzählen ---------- */
function tween(el, to, dur = 600) {
  const from = parseInt(String(el.textContent).replace(/\D/g, "")) || 0;
  if (reduce) { el.textContent = to; return; }
  const t0 = performance.now();
  (function step(t) { const k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3); el.textContent = Math.round(from + (to - from) * e); if (k < 1) requestAnimationFrame(step); })(t0);
}
if (!reduce && "IntersectionObserver" in window) {
  const io = new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return; io.unobserve(e.target);
    const el = e.target, to = +el.dataset.count;
    el.textContent = el.hasAttribute("data-plain") ? to - 46 : 0; setTimeout(() => tween(el, to, 1400), 500);
  }), { threshold: .6 });
  $$("[data-count]").forEach((el) => io.observe(el));
}

/* ---------- Leistungs-Akkordeon ---------- */
$$(".acc-row").forEach((row) => {
  const cards = $$(".acc", row);
  cards.forEach((a) => {
    const open = () => cards.forEach((b) => { const on = b === a; b.classList.toggle("on", on); $(".acc-head", b).setAttribute("aria-expanded", on); });
    $(".acc-head", a).addEventListener("click", open);
    a.addEventListener("mouseenter", () => { if (matchMedia("(hover:hover) and (min-width:1001px)").matches) open(); });
  });
  // Measure every card at its expanded width, without changing the visible selection.
  const sizeToContent = () => {
    if (!matchMedia("(min-width:1001px)").matches || !cards.length) {
      row.style.removeProperty("--acc-content-height");
      cards.forEach((card) => card.style.removeProperty("--acc-body-width"));
      return;
    }
    const measure = row.cloneNode(true);
    measure.removeAttribute("id");
    $$("[id]", measure).forEach((el) => el.removeAttribute("id"));
    measure.setAttribute("aria-hidden", "true");
    measure.inert = true;
    Object.assign(measure.style, {position:"fixed",left:"-100000px",top:"0",width:`${row.getBoundingClientRect().width}px`,height:"auto",visibility:"hidden",pointerEvents:"none",transform:"none"});
    const copies = $$(".acc", measure);
    copies.forEach((card) => {card.style.transition = "none";card.style.removeProperty("--acc-body-width");card.classList.remove("on");});
    row.after(measure);
    let height = 0;
    copies.forEach((card, index) => {
      card.classList.add("on");
      const head = $(".acc-head", card), body = $(".acc-body", card);
      const style = getComputedStyle(card);
      cards[index].style.setProperty("--acc-body-width", `${body.getBoundingClientRect().width}px`);
      height = Math.max(height, head.offsetHeight + body.scrollHeight + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth));
      card.classList.remove("on");
    });
    measure.remove();
    row.style.setProperty("--acc-content-height", `${Math.ceil(height)}px`);
  };
  let frame;
  const scheduleSize = () => {cancelAnimationFrame(frame);frame = requestAnimationFrame(sizeToContent);};
  let lastWidth = -1;
  new ResizeObserver(([entry]) => {
    if (entry.contentRect.width !== lastWidth) {lastWidth = entry.contentRect.width;scheduleSize();}
  }).observe(row);
  addEventListener("resize", scheduleSize, {passive:true});
  document.fonts.ready.then(scheduleSize);
  scheduleSize();
});

/* ---------- Karte (Scrollytelling) ---------- */
const MAP = DATA.karte;
const SINGEN = [8.8403, 47.7594];
function proj(lon, lat) { const r = Math.PI / 180, k = MAP.scale, m = (p) => Math.log(Math.tan(Math.PI / 4 + p * r / 2)); return [MAP.translate[0] + k * (lon - MAP.center[0]) * r, MAP.translate[1] - k * (m(lat) - m(MAP.center[1]))]; }
const TOWNS = [
  ["Rielasingen-Worblingen", 47.7336, 8.8411, 1], ["Gottmadingen", 47.7353, 8.7772, 1], ["Hilzingen", 47.7653, 8.7835, 1],
  ["Radolfzell", 47.7368, 8.9697], ["Engen", 47.8551, 8.7731, 0, "end"], ["Stockach", 47.8513, 9.0083], ["Konstanz", 47.6779, 9.1732],
  ["Schaffhausen", 47.6973, 8.6349, 0, "end"], ["Überlingen", 47.7676, 9.1594], ["Tuttlingen", 47.9849, 8.8183], ["Donaueschingen", 47.9531, 8.5034],
  ["Villingen-Schwenningen", 48.0623, 8.4935], ["Friedrichshafen", 47.6542, 9.4797, 0, "end"]
];
const mapSvg = $("#map");
let pickOnMap = () => {};
if (mapSvg && MAP) (function () {
  const HOME = MAP.singen, RW = MAP.views.region[2] / 520, EW = MAP.views.europa[2] / 520;
  let h = `<path class="town-line" id="townLine" d="" style="stroke-width:${1.8 * RW}px;stroke-dasharray:${4 * RW} ${3 * RW}"/>`;
  TOWNS.forEach(([n, lat, lon, small, anchor], i) => {
    const [x, y] = proj(lon, lat), dx = (anchor === "end" ? -8 : 8) * RW;
    h += `<g class="town-g${small ? " small" : ""}" data-town="${i}"><circle class="town-dot" cx="${x}" cy="${y}" r="${3.4 * RW}" style="stroke-width:${1.4 * RW}px"/><text class="town-l" x="${x + dx}" y="${y + 3.8 * RW}" text-anchor="${anchor || "start"}" style="font-size:${11 * RW}px;stroke-width:${3 * RW}px">${n}</text></g>`;
  });
  $("#mapTowns").innerHTML = h;
  // Europa: Hauptstädte als Punkte (Name als Tooltip), Deutschland: Landeshauptstädte mit Namen
  const DW = MAP.views.deutschland[2] / 520;
  const HAUPT = [["Berlin", 52.52, 13.405], ["Wien", 48.2082, 16.3738], ["Bern", 46.948, 7.4474], ["Paris", 48.8566, 2.3522], ["Rom", 41.9028, 12.4964],
    ["Madrid", 40.4168, -3.7038], ["Lissabon", 38.7223, -9.1393], ["London", 51.5074, -0.1278], ["Dublin", 53.3498, -6.2603], ["Brüssel", 50.8503, 4.3517],
    ["Amsterdam", 52.3676, 4.9041], ["Luxemburg", 49.6116, 6.1319], ["Kopenhagen", 55.6761, 12.5683], ["Oslo", 59.9139, 10.7522], ["Stockholm", 59.3293, 18.0686],
    ["Helsinki", 60.1699, 24.9384], ["Tallinn", 59.437, 24.7536], ["Riga", 56.9496, 24.1052], ["Vilnius", 54.6872, 25.2797], ["Warschau", 52.2297, 21.0122],
    ["Prag", 50.0755, 14.4378], ["Bratislava", 48.1486, 17.1077], ["Budapest", 47.4979, 19.0402], ["Ljubljana", 46.0569, 14.5058], ["Zagreb", 45.815, 15.9819],
    ["Sarajevo", 43.8563, 18.4131], ["Belgrad", 44.7866, 20.4489], ["Podgorica", 42.4304, 19.2594], ["Tirana", 41.3275, 19.8187], ["Skopje", 41.9981, 21.4254],
    ["Pristina", 42.6629, 21.1655], ["Sofia", 42.6977, 23.3219], ["Bukarest", 44.4268, 26.1025], ["Chișinău", 47.0105, 28.8638], ["Kiew", 50.4501, 30.5234],
    ["Athen", 37.9838, 23.7275], ["Valletta", 35.8989, 14.5146]];
  let a = "";
  HAUPT.forEach(([n, lat, lon]) => { const [x, y] = proj(lon, lat); a += `<circle class="cap-dot${n === "Berlin" ? " cap-de" : ""}" cx="${x.toFixed(2)}" cy="${y.toFixed(2)}" r="${2.6 * EW}" style="stroke-width:${1.2 * EW}px"><title>${n}</title></circle>`; });
  $("#mapArcs").innerHTML = a;
  // Landeshauptstädte nur als Punkte, Name als Tooltip
  const LHS = [["Kiel", 54.3233, 10.1228], ["Schwerin", 53.6355, 11.4012], ["Hamburg", 53.5511, 9.9937], ["Bremen", 53.0793, 8.8017],
    ["Hannover", 52.3759, 9.732], ["Berlin", 52.52, 13.405], ["Potsdam", 52.3906, 13.0645], ["Magdeburg", 52.1205, 11.6276],
    ["Düsseldorf", 51.2277, 6.7735], ["Erfurt", 50.9848, 11.0299], ["Dresden", 51.0504, 13.7373], ["Wiesbaden", 50.0782, 8.2398],
    ["Mainz", 49.9929, 8.2473], ["Saarbrücken", 49.2402, 6.9969], ["Stuttgart", 48.7758, 9.1829], ["München", 48.1351, 11.582]];
  let l = "";
  LHS.forEach(([n, lat, lon]) => { const [x, y] = proj(lon, lat); l += `<circle class="town-dot" cx="${x.toFixed(2)}" cy="${y.toFixed(2)}" r="${3 * DW}" style="stroke-width:${1.3 * DW}px"><title>${n}</title></circle>`; });
  $("#mapLhs").innerHTML = l;
  const home = $("#mapHome");
  const viewOf = (n) => { const [x, y, w] = MAP.views[n]; return { cx: x + w / 2, cy: y + w / 2, w }; };
  let V = viewOf("region"), anim = 0, cur = "region";
  function setView(cx, cy, w) {
    mapSvg.setAttribute("viewBox", `${cx - w / 2} ${cy - w / 2} ${w} ${w}`);
    home.setAttribute("transform", `translate(${HOME[0]} ${HOME[1]}) scale(${w / 520})`);
    const layer = w < MAP.views.region[2] * 3 ? "region" : w < MAP.views.deutschland[2] * 1.6 ? "deutschland" : "europa";
    if (mapSvg.dataset.layer !== layer) mapSvg.dataset.layer = layer;
    V = { cx, cy, w };
  }
  function zoomTo(name, dur = 1600) {
    if (name === cur) return; cur = name;
    $$("[data-view]").forEach((b) => b.setAttribute("aria-pressed", b.dataset.view === name));
    const to = viewOf(name), from = { ...V }; cancelAnimationFrame(anim);
    if (reduce) { setView(to.cx, to.cy, to.w); return; }
    const t0 = performance.now(), ease = (t) => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    (function step(t) {
      const k = Math.min(1, (t - t0) / dur), e = ease(k), w = from.w * Math.pow(to.w / from.w, e);
      const s = Math.abs(from.w - to.w) > 1e-6 ? (from.w - w) / (from.w - to.w) : e;
      setView(from.cx + (to.cx - from.cx) * s, from.cy + (to.cy - from.cy) * s, w);
      if (k < 1) anim = requestAnimationFrame(step);
    })(t0);
  }
  setView(V.cx, V.cy, V.w);
  $$("[data-view]").forEach((b) => b.addEventListener("click", () => { mapSvg.closest(".map-card").classList.remove("zeigt-haus"); zoomTo(b.dataset.view); }));
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      $$(".step").forEach((s) => s.classList.toggle("on", s === e.target));
      const haus = e.target.dataset.step === "standort";
      const mapCard = mapSvg.closest(".map-card");
      mapCard.classList.toggle("zeigt-haus", haus && !!mapCard.querySelector(".map-haus img"));
      zoomTo(haus ? "region" : e.target.dataset.step);
    }), { rootMargin: "-30% 0px -62% 0px" }); // Wechsel erst, wenn der Schritt ins obere Drittel kommt
    $$(".step").forEach((s) => io.observe(s));
  }
  pickOnMap = (i) => {
    $$(".town-g").forEach((g) => g.classList.toggle("sel", +g.dataset.town === i));
    const t = TOWNS[i], [x, y] = proj(t[2], t[1]);
    $("#townLine").setAttribute("d", `M${HOME[0]} ${HOME[1]}L${x} ${y}`);
  };
})();

/* ---------- Nähe & Latenz ---------- */
if ($("#towns")) (function () {
  const km = (a, b) => { const r = Math.PI / 180, dLat = (b[0] - a[0]) * r, dLon = (b[1] - a[1]) * r, h = Math.sin(dLat / 2) ** 2 + Math.cos(a[0] * r) * Math.cos(b[0] * r) * Math.sin(dLon / 2) ** 2; return 6371 * 2 * Math.asin(Math.sqrt(h)); };
  const DCS = [["hegau.cloud, Singen", [47.7594, 8.8403], 1], ["Frankfurt am Main", [50.1109, 8.6821]], ["Dublin", [53.3498, -6.2603]], ["US-Ostküste", [39.0438, -77.4874]]];
  const ping = (d) => 0.4 + d * 1.6 * 2 / 200; // Glasfaser ~200 km/ms, Umwegfaktor 1,6, plus Grundlast
  const fmtMs = (v) => v < 1 ? "< 1" : v < 10 ? v.toFixed(1).replace(".", ",") : Math.round(v).toString();
  const NEAR = ["Radolfzell", "Konstanz", "Engen", "Stockach", "Donaueschingen", "Tuttlingen", "Überlingen", "Villingen-Schwenningen", "Friedrichshafen", "Gottmadingen"];
  $("#towns").innerHTML = NEAR.map((n) => `<button class="town" type="button" aria-pressed="${n === "Radolfzell"}" data-near="${n}">${n}</button>`).join("");
  function pick(name) {
    const i = TOWNS.findIndex((t) => t[0] === name), t = TOWNS[i], pos = [t[1], t[2]];
    $$(".town").forEach((b) => b.setAttribute("aria-pressed", b.dataset.near === name));
    $("#latTown").textContent = name;
    const d = km(pos, [SINGEN[1], SINGEN[0]]); tween($("#latKm"), Math.round(d)); $("#latMs").textContent = fmtMs(ping(d));
    const vals = DCS.map(([n, p, h]) => [n, ping(km(pos, p)), h]), max = Math.max(...vals.map((v) => v[1]));
    $("#latRows").innerHTML = vals.map(([n, v, h]) => `<div class="lat-row${h ? " home" : ""}"><span>${n}</span><span class="t"><i class="fill" style="width:${reduce ? Math.max(4, v / max * 100) : 0}%"></i><i class="pkt" style="--d:${Math.round(260 * Math.sqrt(Math.max(v, .6)))}ms"></i></span><output>${fmtMs(v)} ms</output></div>`).join("");
    if (!reduce) requestAnimationFrame(() => requestAnimationFrame(() => $$("#latRows .fill").forEach((f, k) => f.style.width = Math.max(4, vals[k][1] / max * 100) + "%")));
    pickOnMap(i);
  }
  $$(".town").forEach((b) => b.addEventListener("click", () => pick(b.dataset.near)));
  pick("Radolfzell");
})();

/* ---------- Lichtschalter: an = hell, aus = dunkel ---------- */
const root = document.documentElement;
const isDark = () => root.dataset.theme === "dark";
const syncSwitch = () => $$(".switch").forEach((x) => { const on = !isDark(); x.setAttribute("aria-pressed", on); x.setAttribute("aria-label", on ? "Licht ist an. Ausschalten für den dunklen Modus" : "Licht ist aus. Einschalten für den hellen Modus"); });
$$(".switch").forEach((sw) => sw.addEventListener("click", () => { root.dataset.theme = isDark() ? "light" : "dark"; try { localStorage.setItem("troendle-theme", root.dataset.theme); } catch {} syncSwitch(); }));
syncSwitch();

/* ---------- Kopieren ---------- */
function copyText(text, btn) {
  const ok = () => { if (!btn) return; const o = btn.textContent; btn.textContent = "kopiert ✓"; btn.classList.add("done"); setTimeout(() => { btn.textContent = o; btn.classList.remove("done"); }, 1600); };
  const fail = () => { const c = btn && btn.previousElementSibling; if (c) { const r = document.createRange(); r.selectNodeContents(c); const s = getSelection(); s.removeAllRanges(); s.addRange(r); } };
  try { navigator.clipboard.writeText(text).then(ok, fail); } catch (e) { fail(); }
}
document.addEventListener("click", (e) => { const b = e.target.closest("[data-copy]"); if (b) copyText(b.dataset.copy, b); });

/* ---------- Assistent (Sidebar) ---------- */
const K = Object.fromEntries(DATA.kontakte.map((k) => [k.id, k]));
const FLOW = {
  start: { q: "Hallo. Worum geht es?", sub: "Ein paar Klicks, dann wissen Sie, wen Sie erreichen, und wir wissen, worum es geht.", key: "anliegen", o: [["Bei uns funktioniert etwas nicht", "stoerung", "s_bereich"], ["Wir sind schon Kunde", "bestand", "k_was"], ["Wir planen ein neues Projekt", "projekt", "p_thema"], ["Ich möchte einen Termin vereinbaren", "termin", "t_wer"], ["Ich möchte bei Tröndle arbeiten", "bewerbung", "b_stelle"], ["Etwas anderes", "sonst", "r_sonst"]] },
  s_bereich: { q: "Welcher Bereich ist betroffen?", key: "bereich", next: "s_ausmass", o: [
    ["Ein einzelner PC oder Laptop", "pc"], ["Server, Laufwerke oder Netzwerk", "server"], ["Internet oder VPN", "internet"],
    ["E-Mail, Teams oder Microsoft 365", "m365"], ["Telefon oder Telefonanlage", "telefon"], ["Drucker oder Scanner", "drucker"],
    ["Fachanwendung (DocuWare, ERP …)", "software"], ["DATEV", "datev"], ["Alarmierung", "alarm"],
    ["hegau.cloud", "cloud"], ["Angriff, Virus oder Datenpanne", "sicherheit", "r_stoerung"],
    ["Weiß ich nicht genau", "unklar"]] },
  k_was: { q: "Was steht an?", key: "kundenAnliegen", o: [
    ["Benutzer oder Rechte ändern", "benutzer", "r_cockpit"],
    ["Anderer Auftrag oder Einrichtung", "auftrag", "r_auftrag"],
    ["Erweitern oder neu anschaffen", "erweiterung", "r_erweiterung"],
    ["Vertrag, Rechnung oder Lizenzen", "vertrag", "r_vertrag"],
    ["Kundeninfo oder Störungsinfos abonnieren", "infos", "r_infos"],
    ["Etwas anderes", "anderes", "r_sonst"]] },
  s_ausmass: { q: "Wie stark sind Sie eingeschränkt?", key: "ausmass", next: "r_stoerung", o: [["Mehrere Plätze oder alles steht", "kritisch"], ["Ein Arbeitsplatz ist betroffen", "mittel"], ["Läuft noch, bitte ansehen", "gering"]] },
  p_thema: { q: "Welche Themen stehen an?", sub: "Mehrfachauswahl möglich.", key: "themen", multi: true, next: "p_groesse", o: DATA.leistungen.map((t) => [t, t]).concat([["Weiß ich noch nicht", "offen"]]) },
  p_groesse: { q: "Wie viele Arbeitsplätze hat Ihr Unternehmen?", key: "groesse", next: "p_zeit", o: [["1 bis 9", "1–9"], ["10 bis 49", "10–49"], ["50 bis 249", "50–249"], ["250 und mehr", "250+"]] },
  p_zeit: { q: "Wann soll es losgehen?", key: "zeit", next: "r_projekt", o: [["So bald wie möglich", "sofort"], ["In diesem Quartal", "Quartal"], ["Im nächsten Jahr", "nächstes Jahr"], ["Wir informieren uns erst", "informieren"]] },
  t_wer: { q: "Mit wem möchten Sie sprechen?", key: "terminWer", o: [["Vertrieb: Projekt, Angebot, Beratung", "vertrieb", "t_art"], ["Technik: Fragen zu Ihrer IT", "technik", "r_termin_technik"]] },
  t_art: { q: "Worum geht es?", sub: "Die Buchung öffnet sich hier auf der Seite. Sie wählen Tag und Uhrzeit und bekommen sofort eine Bestätigung.", key: "termin", o: DATA.termine.map((t) => [t.titel + " · " + t.dauer + (t.kostenfrei ? " · kostenfrei" : ""), t.id]) },
  b_stelle: { q: "Was interessiert Dich?", key: "stelle", next: "r_bewerbung", o: DATA.stellen.map((s) => [s.kurz || s.titel, s.titel]) }
};
// Landingpage mit Bestellung: Pakete und Preise kommen aus #lp-bestellung (siehe landingpage.njk)
const LPB = (() => { const e = $("#lp-bestellung"); try { return e ? JSON.parse(e.textContent) : null; } catch { return null; } })();
// Konditionen, die für ein Paket gelten (z. B. keine Mindestlaufzeit bei Solo)
const kondFuer = (p) => (LPB && LPB.konditionen || []).filter((k) => !(k.nichtFuer || []).includes(p.name));
const preisZeile = (p) => p.preise.map((x) => `${x.name}: ${x.betrag}`).join(" · ");
if (LPB) FLOW.o_paket = { q: "Welches Paket möchten Sie bestellen?", sub: LPB.hinweis || "", key: "paket", next: "r_bestellen", o: LPB.pakete.map((p) => [`${esc(p.name)}<small>${esc(preisZeile(p))}</small>`, p.name]) };
const PATH_LEN = { stoerung: 3, bestand: 2, projekt: 4, bewerbung: 2, termin: 2, sonst: 1, bestellen: 2 };
// Störungsbereich → Bereich der Cockpit-Schnittstelle und Kontakt (support | datev | alarm)
const apiBereich = (b) => (b === "datev" || b === "alarm" ? b : "support");
let A = {}, hist = [], cur = "start", multiSel = new Set(), lastFocus = null, typingT = 0;
// Optionen dürfen eine Unterzeile <small> tragen (Paketpreise); im Verlauf zählt nur die Beschriftung
const label = (id, v) => { const o = FLOW[id] && FLOW[id].o.find((x) => x[1] === v); return o ? o[0].replace(/<small>[\s\S]*<\/small>/, "") : v; };
function openAssistant(path, preset) {
  lastFocus = document.activeElement; A = {}; hist = []; multiSel = new Set(); cur = "start";
  // Von einer Landingpage (data-liste): ohne Verlauf „schon Kunde“, die Liste ist vorgewählt
  if (path === "infos") { A.anliegen = "bestand"; A.kundenAnliegen = "infos"; if (preset && preset.liste) A.infoVorwahl = preset.liste; else hist = ["start", "k_was"]; cur = "r_infos"; }
  // Landingpage: direkt zum Vertriebsformular, Kampagne und Betreff vorbelegt
  else if (path === "lp") { A.anliegen = "projekt"; A.kampagne = (preset && preset.kampagne) || ""; A.betreff = (preset && preset.betreff) || ""; A.termin = (preset && preset.termin) || ""; cur = "r_lp"; }
  // Bestellung von der Landingpage: Paket wählen (oder vorgewählt aus der Tabelle), dann Bestellformular
  else if (path === "bestellen" && LPB) { A.anliegen = "bestellen"; A.kampagne = LPB.kampagne || ""; if (preset && preset.paket && LPB.pakete.some((p) => p.name === preset.paket)) { A.paket = preset.paket; hist = ["o_paket"]; cur = "r_bestellen"; } else cur = "o_paket"; }
  else if (path && path !== "start") {
    A.anliegen = path; hist.push("start"); cur = FLOW.start.o.find((o) => o[1] === path)[2];
    if (preset && preset.themen) { A.themen = preset.themen; hist.push("p_thema"); cur = "p_groesse"; }
    if (preset && preset.stelle) { A.stelle = preset.stelle; hist.push("b_stelle"); cur = "r_bewerbung"; }
  }
  $("#drawer").classList.add("on"); $("#scrim").classList.add("on"); $("#drawer").setAttribute("aria-hidden", "false"); document.body.style.overflow = "hidden";
  render(true);
  // Keep focus inside the visible dialog even during the typing delay.
  if (!$("#drawer").contains(document.activeElement)) $("#closeBtn").focus({ preventScroll: true });
}
function closeAssistant() { clearTimeout(typingT); $("#drawer").classList.remove("on"); $("#scrim").classList.remove("on"); $("#drawer").setAttribute("aria-hidden", "true"); document.body.style.overflow = ""; if (lastFocus?.isConnected) lastFocus.focus({ preventScroll: true }); }
$("#closeBtn").addEventListener("click", closeAssistant); $("#scrim").addEventListener("click", closeAssistant);
document.addEventListener("keydown", (e) => {
  const d = $("#drawer");
  if (!d.classList.contains("on")) return;
  if (e.key === "Escape") { closeAssistant(); return; }
  if (e.key !== "Tab") return;
  // Fokus bleibt im Dialog
  const f = $$('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]', d).filter((x) => x.offsetParent !== null && x.tabIndex >= 0);
  if (!f.length) return;
  const first = f[0], last = f[f.length - 1];
  if (!d.contains(document.activeElement)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
  else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
});
$("#chat").addEventListener("click", (e) => {
  const b = e.target.closest("[data-infos]"); if (!b) return;
  A.infoVorwahl = b.dataset.infos; cur = "r_infos"; render(true);
});
$("#backBtn").addEventListener("click", () => { if (!hist.length) return; cur = hist.pop(); const k = FLOW[cur].key; if (FLOW[cur].multi) multiSel = new Set(A[k] || []); delete A[k]; if (cur === "start") A = {}; render(false); });
document.addEventListener("click", (e) => {
  const b = e.target.closest("[data-open]"); if (!b) return;
  openAssistant(b.dataset.open, { themen: b.dataset.thema ? [b.dataset.thema] : null, stelle: b.dataset.stelle || null, kampagne: b.dataset.kampagne, betreff: b.dataset.betreff, liste: b.dataset.liste, termin: b.dataset.termin, paket: b.dataset.paket });
});

const answerText = (id) => { const v = A[FLOW[id].key]; return Array.isArray(v) ? v.map((x) => label(id, x)).join(", ") : label(id, v); };
function render(typing) {
  clearTimeout(typingT);
  const chat = $("#chat"); let h = "";
  hist.forEach((id) => { h += `<div class="msg bot old">${FLOW[id].q}</div><div class="msg me old">${esc(answerText(id))}</div>`; });
  const wait = typing && !reduce;
  if (wait) h += `<div class="msg bot typing" id="typing"><i></i><i></i><i></i></div>`;
  h += `<div id="now"${wait ? " hidden" : ""}>`;
  if (FLOW[cur]) {
    const s = FLOW[cur];
    h += `<div class="msg bot">${s.q}${s.sub ? `<small>${s.sub}</small>` : ""}</div><div class="opts">`;
    s.o.forEach(([l, v], i) => { h += `<button class="opt" type="button" data-v="${esc(v)}" ${s.multi ? `aria-pressed="${multiSel.has(v)}"` : ""}><span>${l}</span><span class="k">${s.multi ? (multiSel.has(v) ? "✓" : "+") : (i + 1)}</span></button>`; });
    if (s.multi) h += `<button class="btn btn--red" type="button" id="multiNext" ${multiSel.size ? "" : "disabled"} style="margin-top:.3rem">Weiter <span class="arr">→</span></button>`;
    h += "</div>";
  } else h += result(cur);
  h += "</div>";
  // Keep focus on a persistent dialog control before replacing the focused answer.
  if (chat.contains(document.activeElement)) $("#closeBtn").focus({ preventScroll: true });
  chat.innerHTML = h;
  const total = PATH_LEN[A.anliegen] || 4, done = hist.length;
  $("#progressBar").style.width = (FLOW[cur] ? done / (total + 1) * 100 : 100) + "%";
  $("#stepInfo").textContent = FLOW[cur] ? `${Math.min(done + 1, total)} / ${total}` : "fertig";
  $("#backBtn").disabled = !hist.length;
  $$(".opt", chat).forEach((b) => b.addEventListener("click", () => pick(b.dataset.v)));
  const mn = $("#multiNext"); if (mn) mn.addEventListener("click", () => { A[FLOW[cur].key] = [...multiSel]; go(FLOW[cur].next); });
  const f = $("#leadForm"); if (f) { f.addEventListener("submit", submitLead); pflichtKnopf(f); if ($("#shot", f)) initShots(f); else shots = []; ticketToken(f); }
  $$("[data-copy-mail]", chat).forEach((b) => b.addEventListener("click", () => copyText(mailBody(), b)));
  if ($("#rzCheck", chat)) rzPruefen($("#rzCheck", chat));
  const bf = $("#bestellForm", chat); if (bf) { bf.addEventListener("submit", submitBestellung); pflichtKnopf(bf); ticketToken(bf); }
  const inf = $("#infoForm", chat); if (inf) { inf.addEventListener("submit", submitInfos); pflichtKnopf(inf, () => $$("input[name=liste]:checked", inf).length > 0); ticketToken(inf); }
  // Bestellung: oben an der Zusammenfassung stehen bleiben, nicht ans Ende zum Bestellknopf springen
  const oben = () => { const z = cur === "r_bestellen" && $("#now .result", chat); if (z) chat.scrollTop += z.getBoundingClientRect().top - chat.getBoundingClientRect().top - 12; else chat.scrollTop = chat.scrollHeight; };
  const show = () => { const t = $("#typing"); if (t) t.remove(); $("#now").hidden = false; oben(); const n = $("#now .msg.bot, #now h3, #now .result"); if (n) { n.tabIndex = -1; n.focus({ preventScroll: true }); } else $("#closeBtn").focus({ preventScroll: true }); };
  chat.scrollTop = chat.scrollHeight;
  if (wait) typingT = setTimeout(show, 650); else show();
}
function pick(v) {
  const s = FLOW[cur];
  if (s.multi) { multiSel.has(v) ? multiSel.delete(v) : multiSel.add(v); $$("#chat .opt").forEach((b) => { const on = multiSel.has(b.dataset.v); b.setAttribute("aria-pressed", on); $(".k", b).textContent = on ? "✓" : "+"; }); $("#multiNext").disabled = !multiSel.size; return; }
  if (s.key === "termin") { closeAssistant(); openTermin(v); return; }
  // Nur ein buchbarer Vertriebstermin: Auswahl überspringen und gleich die Buchung öffnen
  if (s.key === "terminWer" && v === "vertrieb" && DATA.termine.length === 1) { closeAssistant(); openTermin(DATA.termine[0].id); return; }
  A[s.key] = v; const o = s.o.find((x) => x[1] === v); go(o[2] || s.next);
}
function go(next) { hist.push(cur); cur = next; multiSel = new Set(); render(true); }
const KEYL = { paket: "Paket", terminWer: "Gespräch mit", kundenAnliegen: "Anliegen", bereich: "Bereich", ausmass: "Ausmaß", themen: "Themen", groesse: "Arbeitsplätze", zeit: "Zeitraum", stelle: "Interesse", stand: "Stand", start: "Start" };
const summaryRows = () => hist.filter((id) => id !== "start").map((id) => `<dt>${KEYL[FLOW[id].key]}</dt><dd>${esc(answerText(id))}</dd>`).join("");
const mailBody = () => hist.filter((id) => id !== "start").map((id) => FLOW[id].q + " " + answerText(id)).join("\n");
const telHref = (t) => "+49" + t.replace(/[^\d]/g, "").replace(/^0/, "");
const callBlock = (id) => { const k = K[id]; return `<div class="callnow"><span>${k.label}</span><a href="tel:${telHref(k.tel)}">${k.tel}</a><span class="callnow-mail">Gerne können Sie uns auch schreiben: <a class="mail" href="mailto:${k.mail}">${k.mail}</a></span></div>`; };
// Formular des Assistenten. art: stoerung | auftrag | vertrieb | allgemein (bestimmt im Cockpit die TANSS-Abteilung)
function leadForm(art) {
  const ticket = art === "stoerung" || art === "auftrag";
  const pf = (t) => `${t} (Pflicht)`, req = ' required aria-required="true"';
  const msgLabel = { stoerung: pf("Was ist passiert?"), auftrag: pf("Was sollen wir erledigen?"), vertrieb: "Worum geht es? (optional)", allgemein: pf("Ihre Nachricht") }[art];
  const msgPlatz = { stoerung: "z. B. Outlook startet nicht, Fehlermeldung …", auftrag: "z. B. neuen Arbeitsplatz einrichten, Drucker umziehen …", vertrieb: "z. B. 15 Arbeitsplätze, Umzug im Frühjahr …", allgemein: "" }[art];
  const knopf = { stoerung: "Ticket anlegen", auftrag: "Auftrag senden", vertrieb: "Rückruf anfordern", allgemein: "Nachricht senden" }[art];
  // Eigener Betreff (optional): macht das Ticket auch Wochen später noch auffindbar
  const betreffPlatz = { stoerung: "z. B. Drucker im Empfang druckt nicht", auftrag: "z. B. Arbeitsplatz für neue Kollegin einrichten", vertrieb: "z. B. Angebot für neue Firewall", allgemein: "z. B. Frage zur Rechnung März" }[art];
  return `<form class="form" id="leadForm" data-kind="${art}" novalidate>
    <div class="two"><label>${pf("Name")}<input id="f-name" autocomplete="name"${req}></label><label>${pf("Firma")}<input id="f-firma" autocomplete="organization"${req}></label></div>
    <div class="two"><label>${pf("Telefon")}<input id="f-tel" type="tel" autocomplete="tel"${req}></label><label>Rückruf am besten<select id="f-slot"><option>vormittags</option><option>nachmittags</option><option>egal</option></select></label></div>
    <label>${pf("E-Mail")}<input id="f-mail" type="email" autocomplete="email"${req} aria-describedby="mailHint"></label><p class="fine" id="mailHint" style="margin-top:-.3rem">${ticket ? "Darüber ordnen wir Ihr Ticket Ihrer Firma zu." : "Für die Bestätigung und unsere Antwort."}</p>
    <label>Betreff in einer Zeile (optional)<input id="f-betreff" maxlength="120" autocomplete="off" placeholder="${betreffPlatz}"${A.betreff ? ` value="${esc(A.betreff.slice(0, 120))}"` : ""}></label>
    <label>${msgLabel}<textarea id="f-msg" rows="3"${art === "vertrieb" ? "" : req}${msgPlatz ? ` placeholder="${msgPlatz}"` : ""}></textarea></label>
    <div class="hp" aria-hidden="true"><label>Website<input id="f-website" name="website" tabindex="-1" autocomplete="off"></label></div>
    ${ticket ? `<div class="shot" id="shot"><span class="shot-l" id="shotL">Screenshot ${art === "stoerung" ? "der Fehlermeldung " : ""}(optional)</span><div class="shot-row"><label class="btn btn--sm shot-pick">Bild auswählen<input id="f-shot" type="file" accept="image/png,image/jpeg" multiple class="sr-only" aria-describedby="shotL shotHint"></label>${navigator.mediaDevices?.getDisplayMedia ? `<button class="btn btn--sm" type="button" id="shotCap">Bildschirm aufnehmen</button>` : ""}</div><p class="fine" id="shotHint">Oder mit Strg+V einfügen. Bis zu ${SHOT_MAX} Bilder (PNG oder JPG), je höchstens 5 MB.</p><ul class="shot-list" id="shotList" aria-live="polite"></ul></div>` : ""}
    <button class="btn btn--red" type="submit">${knopf} <span class="arr">→</span></button>
    <p class="fine">Wir nutzen Ihre Angaben nur für diese Anfrage. Hinweise dazu in der <a href="${L.datenschutzWebsite || L.datenschutz}" target="_blank" rel="noopener">Datenschutzerklärung</a>.</p>
  </form>`;
}
// Screenshots im Störungs-Formular: Datei wählen, Strg+V oder Bildschirm aufnehmen
const SHOT_MAX = 3, SHOT_BYTES = 5 * 1024 * 1024;
let shots = [];
function initShots(f) {
  shots = [];
  const list = $("#shotList", f), hint = $("#shotHint", f);
  const zeig = () => {
    list.innerHTML = shots.map((s, i) => `<li><img src="${s.url}" alt=""><span>${esc(s.file.name)}</span><button type="button" class="icon-btn" data-shot-weg="${i}" aria-label="Screenshot ${esc(s.file.name)} entfernen"><svg class="ico" aria-hidden="true"><use href="#i-x"/></svg></button></li>`).join("");
  };
  const add = (files) => {
    let msg = "";
    for (const file of files) {
      if (!/^image\/(png|jpeg)$/.test(file.type)) { msg = "Bitte nur PNG- oder JPG-Bilder anhängen."; continue; }
      if (file.size > SHOT_BYTES) { msg = `${file.name} ist größer als 5 MB.`; continue; }
      if (shots.length >= SHOT_MAX) { msg = `Höchstens ${SHOT_MAX} Bilder.`; break; }
      shots.push({ file, url: URL.createObjectURL(file) });
    }
    hint.textContent = msg || `Oder mit Strg+V einfügen. Bis zu ${SHOT_MAX} Bilder (PNG oder JPG), je höchstens 5 MB.`;
    hint.classList.toggle("err", !!msg);
    zeig();
  };
  $("#f-shot", f).addEventListener("change", (e) => { add(e.target.files); e.target.value = ""; });
  f.addEventListener("paste", (e) => { const fl = [...(e.clipboardData?.files || [])]; if (fl.length) { e.preventDefault(); add(fl); } });
  list.addEventListener("click", (e) => { const b = e.target.closest("[data-shot-weg]"); if (!b) return; const [s] = shots.splice(+b.dataset.shotWeg, 1); URL.revokeObjectURL(s.url); zeig(); $("#f-shot", f).focus(); });
  $("#shotCap", f)?.addEventListener("click", async () => {
    try {
      const stream = await navigator.mediaDevices.getDisplayMedia({ video: true, audio: false });
      const v = document.createElement("video"); v.srcObject = stream; v.muted = true; await v.play();
      await new Promise((r) => requestAnimationFrame(r));
      const c = document.createElement("canvas"); c.width = v.videoWidth; c.height = v.videoHeight; c.getContext("2d").drawImage(v, 0, 0);
      stream.getTracks().forEach((t) => t.stop());
      const blob = await new Promise((r) => c.toBlob(r, "image/jpeg", 0.85));
      add([new File([blob], `bildschirm-${new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-")}.jpg`, { type: "image/jpeg" })]);
    } catch { /* abgebrochen */ }
  });
}
// Ticket ans Cockpit: GET links.ticketForm liefert {aktiv, aufgabe:{token}}, POST links.ticketApi legt an.
// Leer = Prototyp ohne Versand. Das Token gilt frühestens 3 s, spätestens 2 h nach dem Abruf.
let tkt = { token: "", zeit: 0 };
// „Mehrere Plätze oder alles steht“ geht als ausmass=hoch ans Cockpit (Kundenworte in Betreff und Bestätigung)
const AUSMASS_HOCH = true;
async function holeToken() {
  const r = await fetch(L.ticketForm, { headers: { Accept: "application/json" } });
  if (!r.ok) throw new Error("form " + r.status);
  const j = await r.json();
  tkt = { token: j.aufgabe?.token || "", zeit: Date.now(), aktiv: j.aktiv !== false };
  return tkt;
}
function ticketToken(f) {
  if (!L.ticketApi || !L.ticketForm) return;
  holeToken().then((t) => {
    if (t.aktiv || !f.isConnected) return;
    f.outerHTML = `<div class="sent" role="status"><strong>Online-Meldungen sind gerade nicht möglich.</strong> Bitte melden Sie die Störung im <a href="${L.portal}" target="_blank" rel="noopener">Kundenportal</a>, per Mail oder am Telefon.</div>`;
  }).catch(() => { /* beim Absenden erneut versuchen */ });
}
async function sendTicket(f) {
  if (!tkt.token || Date.now() - tkt.zeit > 115 * 60 * 1000) await holeToken();
  const warte = 3200 - (Date.now() - tkt.zeit);
  if (warte > 0) await new Promise((r) => setTimeout(r, warte));
  const v = (id) => $(id, f)?.value.trim() || "";
  const fd = new FormData();
  fd.append("name", v("#f-name")); fd.append("firma", v("#f-firma")); fd.append("telefon", v("#f-tel"));
  const art = f.dataset.kind;
  fd.append("art", art);
  fd.append("email", v("#f-mail")); fd.append("rueckruf", v("#f-slot"));
  if (v("#f-betreff")) fd.append("betreff", v("#f-betreff").slice(0, 120));
  fd.append("nachricht", v("#f-msg") || "Anfrage über den Assistenten auf troendle.de (Angaben siehe Verlauf).");
  if (art === "stoerung") { fd.append("bereich", apiBereich(A.bereich)); fd.append("ausmass", A.ausmass === "kritisch" ? (AUSMASS_HOCH ? "hoch" : "mittel") : (A.ausmass || "gering")); }
  if (art === "auftrag") { fd.append("bereich", "support"); fd.append("ausmass", "gering"); }
  // Landingpage: die Kampagne steht als erster Eintrag im Verlauf (die Adresse mit utm_-Angaben steht in „seite“)
  fd.append("verlauf", JSON.stringify((A.kampagne ? [{ frage: "Kampagne", antwort: A.kampagne }] : []).concat(hist.filter((id) => id !== "start").map((id) => ({ frage: KEYL[FLOW[id].key], antwort: answerText(id) })))));
  fd.append("seite", location.href.slice(0, 500)); fd.append("token", tkt.token); fd.append("website", $("#f-website", f)?.value || "");
  shots.forEach((s) => fd.append("screenshot", s.file, s.file.name));
  const r = await fetch(L.ticketApi, { method: "POST", body: fd, headers: { Accept: "application/json" } });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) { if (r.status === 400) tkt.token = ""; const e = new Error(j.message || "HTTP " + r.status); e.status = r.status; e.text = j.message; throw e; }
  return { nr: j.ticketnummer || j.ticketNumber || "", bestaetigung: j.bestaetigung === true, anhaenge: j.anhaenge || "keine" };
}
// Info-Anmeldung: Kundeninfo (Newsletter) und Störungsinformationen der hegau.cloud.
// Nichts ist vorausgewählt (Einwilligung); Anmeldung mit Bestätigungsmail (Double-Opt-in) im Cockpit.
function infoForm() {
  const vor = A.infoVorwahl || "";
  const box = (v, t, d) => `<label class="check"><input type="checkbox" name="liste" value="${v}"${vor === v ? " checked" : ""}><span><b>${t}</b><small>${d}</small></span></label>`;
  return `<form class="form" id="infoForm" novalidate>
    <fieldset class="checks"><legend class="sr-only">Was möchten Sie bekommen?</legend>
      ${box("kundeninfo", "Kundeninfo", "Neuigkeiten, Sicherheitswarnungen und Einladungen aus dem Systemhaus.")}
      ${box("stoerung", "Störungsinformationen", "Störungen und geplante Wartungen der hegau.cloud, direkt von unserer Statusseite.")}
    </fieldset>
    <div class="two"><label>Name (optional)<input id="i-name" autocomplete="name" maxlength="120"></label><label>Firma (optional)<input id="i-firma" autocomplete="organization" maxlength="160"></label></div>
    <label>E-Mail *<input id="i-mail" type="email" autocomplete="email" required aria-required="true"></label>
    <div class="hp" aria-hidden="true"><label>Website<input id="i-website" name="website" tabindex="-1" autocomplete="off"></label></div>
    <button class="btn btn--red" type="submit">Anmelden <span class="arr">→</span></button>
    <p class="fine">Sie bekommen zuerst eine Mail, in der Sie die Anmeldung bestätigen. Hinweise in der <a href="${L.datenschutzWebsite || L.datenschutz}" target="_blank" rel="noopener">Datenschutzerklärung</a>.</p>
  </form>`;
}
function submitInfos(e) {
  e.preventDefault(); const f = e.target, btn = $("button[type=submit]", f);
  const listen = $$("input[name=liste]:checked", f).map((i) => i.value), mail = $("#i-mail", f), v = mail.value.trim();
  let p = $(".err", f);
  const fehler = !listen.length ? "Bitte wählen Sie mindestens eine Information aus." : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? "Bitte eine gültige E-Mail-Adresse angeben." : "";
  mail.setAttribute("aria-invalid", fehler && listen.length ? "true" : "false");
  if (fehler) { if (!p) { p = document.createElement("p"); p.className = "err"; p.setAttribute("role", "alert"); f.insertBefore(p, btn); } p.textContent = fehler; (listen.length ? mail : $("input[name=liste]", f)).focus(); return; }
  const fertig = (html) => { f.outerHTML = `<div class="sent" role="status">${html}</div>`; };
  const stoerLink = listen.includes("stoerung") ? ` Die Störungsinformationen können Sie auch direkt auf der <a href="${L.statusAbo}" target="_blank" rel="noopener">Statusseite der hegau.cloud</a> abonnieren.` : "";
  if (!L.infoApi || !L.ticketForm) { fertig(`<strong>Prototyp:</strong> Hier wurde nichts verschickt. Live bekämen Sie jetzt eine Mail zur Bestätigung.${stoerLink}`); return; }
  btn.disabled = true; btn.dataset.sendet = "1"; btn.textContent = "Wird angemeldet …";
  (async () => {
    if (!tkt.token || Date.now() - tkt.zeit > 115 * 60 * 1000) await holeToken();
    const warte = 3200 - (Date.now() - tkt.zeit); if (warte > 0) await new Promise((r) => setTimeout(r, warte));
    const fd = new FormData();
    fd.append("email", v); fd.append("name", $("#i-name", f).value.trim()); fd.append("firma", $("#i-firma", f).value.trim());
    listen.forEach((l) => fd.append("liste", l));
    fd.append("seite", location.href.slice(0, 500)); fd.append("token", tkt.token); fd.append("website", $("#i-website", f).value);
    const r = await fetch(L.infoApi, { method: "POST", body: fd, headers: { Accept: "application/json" } });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) { if (r.status === 400) tkt.token = ""; const err = new Error(j.message || "HTTP " + r.status); err.text = j.message; throw err; }
  })().then(() => fertig("<strong>Fast geschafft.</strong> Bitte bestätigen Sie die Anmeldung über den Link in der Mail, die wir Ihnen gerade geschickt haben."))
    .catch((err) => {
      delete btn.dataset.sendet; btn.disabled = false; btn.innerHTML = 'Erneut versuchen <span class="arr">→</span>';
      if (!p) { p = document.createElement("p"); p.className = "err"; p.setAttribute("role", "alert"); f.insertBefore(p, btn); }
      p.innerHTML = `${err.text ? esc(err.text) + " " : ""}Die Anmeldung hat gerade nicht geklappt. Bitte versuchen Sie es später noch einmal.${stoerLink}`;
    });
}
// Meldung zur hegau.cloud: Ist auf der Statusseite schon eine Störung oder Wartung bekannt?
function rzPruefen(box) {
  const uhr = (t) => { const d = new Date(t); return isNaN(d) ? "" : ` seit ${d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" })} Uhr`; };
  const abo = `<div class="row"><button class="btn" type="button" data-infos="stoerung">Störungsinfos per Mail abonnieren</button><a class="btn" href="${L.status}" target="_blank" rel="noopener">Zur Statusseite</a></div>`;
  rzStatus(60 * 1000).then((sm) => {
    const st = sm && sm.page && sm.page.status, inc = (sm && sm.activeIncidents) || [], wart = (sm && sm.activeMaintenances) || [];
    if (st === "HASISSUES" || inc.length) {
      box.classList.add("rz-bekannt");
      box.innerHTML = `<h3>Diese Störung kennen wir schon.</h3>${inc.length ? `<ul class="rz-liste">${inc.map((i) => `<li><b>${esc(i.name || "Störung")}</b>${uhr(i.started)}</li>`).join("")}</ul>` : ""}<p style="font-size:var(--s-1)">Unser Team arbeitet bereits daran. Den aktuellen Stand finden Sie auf der Statusseite. Ein Ticket brauchen Sie nur, wenn bei Ihnen etwas anderes nicht funktioniert.</p>${abo}`;
    } else if (st === "UNDERMAINTENANCE" || wart.length) {
      box.classList.add("rz-bekannt");
      box.innerHTML = `<h3>Gerade laufen geplante Wartungsarbeiten.</h3>${wart.length ? `<ul class="rz-liste">${wart.map((i) => `<li><b>${esc(i.name || "Wartung")}</b>${uhr(i.start || i.started)}</li>`).join("")}</ul>` : ""}<p style="font-size:var(--s-1)">Einschränkungen in dieser Zeit sind möglich. Details auf der Statusseite.</p>${abo}`;
    } else {
      box.innerHTML = `<p style="font-size:var(--s-1)"><b>Auf der Statusseite ist gerade keine Störung gemeldet.</b> Bitte melden Sie sie uns, damit wir sofort nachsehen. Tipp: Mit den Störungsinfos per Mail erfahren Sie künftig als Erstes, wenn etwas ist.</p>${abo}`;
    }
  }).catch(() => { box.innerHTML = `<p style="font-size:var(--s-1)">Die Statusseite war gerade nicht erreichbar. Bitte melden Sie die Störung, wir sehen sofort nach.</p>${abo}`; });
}
// Absendeknopf bleibt inaktiv, bis alle Pflichtfelder gültig sind (Checkboxen angekreuzt, E-Mail plausibel).
// Ein Hinweis darunter sagt, warum. Die Prüfung beim Absenden bleibt als zweite Sicherung bestehen.
function pflichtKnopf(f, extra) {
  const btn = $("button[type=submit]", f); if (!btn) return;
  const hint = document.createElement("p"); hint.className = "fine pflicht-hint"; hint.id = f.id + "Pflicht";
  hint.textContent = "Der Knopf wird aktiv, sobald alle Pflichtfelder ausgefüllt sind.";
  btn.after(hint); btn.setAttribute("aria-describedby", hint.id);
  const ok = () => $$("[required]", f).every((i) => i.type === "checkbox" ? i.checked : i.type === "email" ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(i.value.trim()) : i.value.trim() !== "") && (!extra || extra());
  const pruefe = () => { if (btn.dataset.sendet) return; const gut = ok(); btn.disabled = !gut; hint.hidden = gut; };
  f.addEventListener("input", pruefe); f.addEventListener("change", pruefe); pruefe();
}
function submitLead(e) {
  e.preventDefault(); const f = e.target, need = $$("[required]", f); let bad = false;
  need.forEach((i) => { const v = i.value.trim(); const miss = !v || (i.type === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)); i.setAttribute("aria-invalid", miss); if (miss) bad = true; });
  if (bad) {
    let p = $(".err", f);
    if (!p) { p = document.createElement("p"); p.className = "err"; p.id = "formErr"; p.setAttribute("role", "alert"); f.insertBefore(p, $("button[type=submit]", f)); }
    p.textContent = f.dataset.kind !== "bewerbung" ? "Bitte die Pflichtfelder ausfüllen, mit gültiger E-Mail-Adresse." : f.dataset.kind === "bewerbung" ? "Bitte Name und Telefonnummer angeben, damit wir Dich zurückrufen können." : "Bitte Name und Telefonnummer angeben, damit wir zurückrufen können.";
    need.forEach((i) => i.setAttribute("aria-describedby", "formErr"));
    need.find((i) => i.getAttribute("aria-invalid") === "true").focus();
    return;
  }
  const art = f.dataset.kind, ticket = art === "stoerung" || art === "auftrag";
  if (L.ticketApi && L.ticketForm) {
    const btn = $("button[type=submit]", f);
    btn.disabled = true; btn.dataset.sendet = "1"; btn.textContent = ticket ? "Ticket wird angelegt …" : "Wird gesendet …";
    sendTicket(f).then((t) => {
      shots.forEach((s) => URL.revokeObjectURL(s.url)); shots = [];
      const kopf = !ticket ? (t.nr ? `Danke, Ihre Anfrage ist bei uns (Vorgang ${esc(String(t.nr))}).` : "Danke, Ihre Anfrage ist bei uns.") : t.nr ? `Ihr Ticket ${esc(String(t.nr))} ist angelegt.` : "Ihre Meldung ist eingegangen.";
      const nr = !ticket ? (art === "vertrieb" ? " Wir rufen Sie zur gewünschten Zeit zurück." : "") : t.nr ? " Bitte halten Sie die Nummer bereit, falls Sie anrufen." : "";
      // Bestätigungsmail nur ankündigen, wenn das Cockpit sie wirklich verschickt hat (bei Vertrieb/Allgemein nie)
      const mail = t.bestaetigung ? " Eine Eingangsbestätigung kommt per Mail." : ticket ? " Wir melden uns bei Ihnen." : "";
      const bild = t.anhaenge === "nicht-uebertragen" ? `<br>Die Screenshots konnten wir leider nicht übernehmen. Bitte schicken Sie sie bei Bedarf als Antwort auf die Bestätigung oder an <a href="mailto:${K[A.bereich]?.mail || K.support.mail}">${K[A.bereich]?.mail || K.support.mail}</a>.` : "";
      const info = A.bereich === "cloud" ? `<br><button class="copy" type="button" data-infos="stoerung">Störungsinfos per Mail abonnieren</button>` : A.anliegen === "bestand" ? `<br><button class="copy" type="button" data-infos="kundeninfo">Kundeninfo per Mail abonnieren</button>` : "";
      f.outerHTML = `<div class="sent" role="status"><strong>${kopf}</strong>${nr}${mail}${bild}${info}</div>`;
    }).catch((err) => {
      delete btn.dataset.sendet; btn.disabled = false; btn.innerHTML = 'Erneut versuchen <span class="arr">→</span>';
      let p = $(".err[role=alert]", f);
      if (!p) { p = document.createElement("p"); p.className = "err"; p.setAttribute("role", "alert"); f.insertBefore(p, btn); }
      const grund = err.status === 413 ? "Ein Bild ist zu groß (höchstens 5 MB). " : err.status === 400 && err.text ? `${esc(err.text)} ` : err.status === 503 ? "Online-Meldungen sind gerade abgeschaltet. " : "";
      p.innerHTML = ticket
        ? `${grund}Das Ticket konnte gerade nicht angelegt werden. Bitte versuchen Sie es erneut, melden Sie sich im <a href="${L.portal}" target="_blank" rel="noopener">Kundenportal</a> oder rufen Sie an.`
        : `${grund}Ihre Anfrage konnte gerade nicht gesendet werden. Bitte versuchen Sie es erneut oder rufen Sie uns an.`;
    });
    return;
  }
  const to = { stoerung: "den Support", auftrag: "den Support", vertrieb: "den Vertrieb", allgemein: "die Zentrale" }[art];
  f.outerHTML = `<p class="sent"><strong>Prototyp:</strong> Hier wurde nichts verschickt. Live ginge Ihre Anfrage als Ticket an ${to}, und Sie bekämen eine Bestätigung per Mail.</p>`;
}
// Bestellung (nur B2B): verbindlich für den Kunden, der Vertrag kommt erst mit unserer Auftragsbestätigung zustande.
// Geht als Vertriebs-Ticket an die Cockpit-Route; alle Angaben stehen in Betreff, Nachricht und Verlauf.
function bestellForm(p) {
  const pf = (t) => `${t} (Pflicht)`, req = ' required aria-required="true"';
  const box = (id, html) => `<label class="check"><input type="checkbox" id="${id}"${req}><span><small>${html}</small></span></label>`;
  const zus = (LPB.zustimmungen || []).filter((z) => !(z.nichtFuer || []).includes(p.name));
  return `<form class="form" id="bestellForm" novalidate>
    <div class="two"><label>${pf("Firma")}<input id="o-firma" autocomplete="organization"${req}></label><label>${pf("Ihr Name")}<input id="o-name" autocomplete="name"${req}></label></div>
    <label>${pf("Straße und Hausnummer")}<input id="o-strasse" autocomplete="address-line1"${req}></label>
    <div class="two"><label>${pf("PLZ")}<input id="o-plz" autocomplete="postal-code" inputmode="numeric"${req}></label><label>${pf("Ort")}<input id="o-ort" autocomplete="address-level2"${req}></label></div>
    <div class="two"><label>${pf("E-Mail")}<input id="o-mail" type="email" autocomplete="email"${req}></label><label>${pf("Telefon")}<input id="o-tel" type="tel" autocomplete="tel"${req}></label></div>
    <label>Ihre Bestellnummer (optional)<input id="o-ref" autocomplete="off"></label>
    <label>Anmerkung (optional)<textarea id="o-msg" rows="2"></textarea></label>
    <div class="hp" aria-hidden="true"><label>Website<input id="o-website" name="website" tabindex="-1" autocomplete="off"></label></div>
    <fieldset class="checks"><legend class="sr-only">Bestätigungen</legend>
      ${box("o-b2b", "Wir bestellen als Unternehmen, und ich bin berechtigt, diese Bestellung für die Firma abzugeben.")}
      ${box("o-agb", `Es gelten die <a href="${esc(LPB.agb || L.agb)}" target="_blank" rel="noopener">AGB und besonderen Vertragsbedingungen</a> der Systemhaus Tröndle GmbH.`)}
      ${zus.map((z, i) => box("o-zus" + i, esc(z.text))).join("")}
    </fieldset>
    <button class="btn btn--red" type="submit">Verbindlich bestellen <span class="arr">→</span></button>
    <p class="fine">Ihre Bestellung ist verbindlich. Der Vertrag kommt zustande, sobald wir sie mit einer Auftragsbestätigung per Mail annehmen. Hinweise zum Datenschutz in der <a href="${L.datenschutzWebsite || L.datenschutz}" target="_blank" rel="noopener">Datenschutzerklärung</a>.</p>
  </form>`;
}
function submitBestellung(e) {
  e.preventDefault(); const f = e.target, need = $$("[required]", f); let bad = false;
  need.forEach((i) => { const v = i.type === "checkbox" ? (i.checked ? "x" : "") : i.value.trim(); const miss = !v || (i.type === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)); i.setAttribute("aria-invalid", miss); if (miss) bad = true; });
  let p = $(".err[role=alert]", f); const btn = $("button[type=submit]", f);
  const fehler = (t) => { if (!p) { p = document.createElement("p"); p.className = "err"; p.setAttribute("role", "alert"); f.insertBefore(p, btn); } p.innerHTML = t; };
  if (bad) { fehler("Bitte alle Pflichtfelder ausfüllen, mit gültiger E-Mail-Adresse, und die Bestätigungen ankreuzen."); need.find((i) => i.getAttribute("aria-invalid") === "true").focus(); return; }
  if (!L.ticketApi || !L.ticketForm) { f.outerHTML = `<p class="sent"><strong>Prototyp:</strong> Hier wurde nichts bestellt. Live ginge Ihre Bestellung an den Vertrieb, und Sie bekämen nach der Prüfung eine Auftragsbestätigung per Mail.</p>`; return; }
  btn.disabled = true; btn.dataset.sendet = "1"; btn.textContent = "Bestellung wird gesendet …";
  sendBestellung(f).then((t) => {
    f.outerHTML = `<div class="sent" role="status"><strong>Danke, Ihre Bestellung ist bei uns eingegangen${t.nr ? ` (Vorgang ${esc(String(t.nr))})` : ""}.</strong> Wir prüfen sie und schicken Ihnen die Auftragsbestätigung per Mail. Erst damit kommt der Vertrag zustande.</div>`;
  }).catch((err) => {
    delete btn.dataset.sendet; btn.disabled = false; btn.innerHTML = 'Erneut versuchen <span class="arr">→</span>';
    fehler(`${err.status === 400 && err.text ? esc(err.text) + " " : ""}Die Bestellung konnte gerade nicht gesendet werden. Bitte versuchen Sie es erneut oder rufen Sie uns an.`);
  });
}
async function sendBestellung(f) {
  if (!tkt.token || Date.now() - tkt.zeit > 115 * 60 * 1000) await holeToken();
  const warte = 3200 - (Date.now() - tkt.zeit); if (warte > 0) await new Promise((r) => setTimeout(r, warte));
  const v = (id) => $(id, f)?.value.trim() || "";
  const p = LPB.pakete.find((x) => x.name === A.paket);
  const zus = $$("input[id^=o-zus]", f).map((i) => i.closest("label").textContent.trim());
  const zeit = new Date().toLocaleString("de-DE", { timeZone: "Europe/Berlin" });
  const fd = new FormData();
  fd.append("name", v("#o-name")); fd.append("firma", v("#o-firma")); fd.append("telefon", v("#o-tel")); fd.append("email", v("#o-mail"));
  fd.append("art", "vertrieb");
  fd.append("betreff", `Bestellung: ${LPB.produkt} ${p.name}`.slice(0, 120));
  fd.append("nachricht", [
    `VERBINDLICHE BESTELLUNG über ${location.hostname} (${zeit})`,
    `Produkt: ${LPB.produkt}`, `Paket: ${p.name}`, ...p.preise.map((x) => `${x.name}: ${x.betrag}`), LPB.hinweis || "Alle Preise zzgl. USt.",
    ...(kondFuer(p).length ? ["", "Konditionen laut Bestellseite:", ...kondFuer(p).map((k) => `${k.name}: ${k.wert}`)] : []),
    "", "Rechnungsanschrift:", v("#o-firma"), v("#o-name"), v("#o-strasse"), `${v("#o-plz")} ${v("#o-ort")}`,
    v("#o-ref") ? `Bestellnummer des Kunden: ${v("#o-ref")}` : "",
    "", "Bestätigt: Bestellung als Unternehmen und berechtigt · AGB und besondere Vertragsbedingungen", ...zus.map((z) => `Bestätigt: ${z}`),
    v("#o-msg") ? `\nAnmerkung: ${v("#o-msg")}` : ""
  ].filter((x, i, a) => x !== "" || a[i - 1] !== "").join("\n"));
  fd.append("verlauf", JSON.stringify([{ frage: "Kampagne", antwort: A.kampagne || LPB.produkt }, { frage: "Bestellung", antwort: `${LPB.produkt} ${p.name}` }].concat(p.preise.map((x) => ({ frage: x.name, antwort: x.betrag })))));
  fd.append("seite", location.href.slice(0, 500)); fd.append("token", tkt.token); fd.append("website", v("#o-website"));
  const r = await fetch(L.ticketApi, { method: "POST", body: fd, headers: { Accept: "application/json" } });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) { if (r.status === 400) tkt.token = ""; const e = new Error(j.message || "HTTP " + r.status); e.status = r.status; e.text = j.message; throw e; }
  return { nr: j.ticketnummer || j.ticketNumber || "" };
}
const L = DATA.links;
// Versand nur auf unseren Domains und lokalen Testhosts; das Cockpit muss diese Origins ebenfalls erlauben.
// Überall sonst (z. B. Vorschau als Artifact) bleibt der Assistent ohne Versand.
if (!/(^|\.)(troendle\.de|hegau\.cloud)$|^localhost$|^127\.0\.0\.1$/.test(location.hostname)) { L.ticketForm = ""; L.ticketApi = ""; L.infoApi = ""; }
function result(id) {
  if (id === "r_stoerung") {
    const b = apiBereich(A.bereich);
    const rz = A.bereich === "cloud" ? `<div class="result rz-check" id="rzCheck" aria-live="polite"><p style="font-size:var(--s-1)">Wir sehen nach, ob auf der Statusseite schon eine Störung gemeldet ist …</p></div>` : "";
    if (A.bereich === "sicherheit") return `<div class="result alert"><h3>Bitte rufen Sie sofort an.</h3>${callBlock("support")}<p style="font-size:var(--s-1)">Bei Verdacht auf einen Angriff oder eine Datenpanne zählt jede Minute. Bitte nichts löschen und keine Lösegeldforderung beantworten. Wir sagen Ihnen am Telefon, was jetzt zu tun ist.</p></div>`;
    // Mehrere Plätze oder alles steht: trotzdem Ticket anbieten, dazu den Anruf als schnellsten Weg
    if (A.ausmass === "kritisch") return `${rz}<div class="result"><h3>Wir legen ein Ticket an.</h3><dl>${summaryRows()}</dl>${leadForm("stoerung")}</div><div class="result alert"><h3>Es eilt? Rufen Sie zusätzlich an.</h3>${callBlock(b)}<p style="font-size:var(--s-1)">Wenn mehrere Arbeitsplätze stehen, geht es am Telefon am schnellsten. Halten Sie die Fernwartung bereit:</p><div class="tool"><button class="btn btn--light" type="button" data-fernwartung>Fernwartung starten</button></div></div>`;
    return `${rz}<div class="result"><h3>Wir legen ein Ticket an.</h3><dl>${summaryRows()}</dl>${leadForm("stoerung")}</div><div class="result"><p style="font-size:var(--s-1)">Lieber per Mail oder im Kundenportal?</p><div class="row"><button class="btn" type="button" data-copy-mail>Text für Mail kopieren</button><a class="btn" href="${L.portal}" target="_blank" rel="noopener">Kundenportal</a></div>${callBlock(b)}</div>`;
  }
  if (id === "r_bestellen") {
    const p = LPB && LPB.pakete.find((x) => x.name === A.paket);
    if (!p) return "";
    const zeilen = p.preise.map((x) => `<dt>${esc(x.name)}</dt><dd>${esc(x.betrag)}</dd>`).join("") + kondFuer(p).map((k) => `<dt>${esc(k.name)}</dt><dd>${esc(k.wert)}</dd>`).join("");
    return `<div class="result"><h3>Ihre Bestellung: ${esc(LPB.produkt)} ${esc(p.name)}</h3><dl>${zeilen}</dl><p class="fine">${esc(LPB.hinweis || "Alle Preise zzgl. der gesetzlichen Umsatzsteuer.")}</p>${bestellForm(p)}</div><div class="result"><p style="font-size:var(--s-1)">Fragen vor der Bestellung?</p>${callBlock("vertrieb")}</div>`;
  }
  if (id === "r_lp") return `<div class="result"><h3>Schön, dass Sie sich melden.</h3>${A.kampagne ? `<dl><dt>Thema</dt><dd>${esc(A.kampagne)}</dd></dl>` : ""}<p style="font-size:var(--s-1);color:var(--fg-2)">Sagen Sie uns kurz, wann wir Sie am besten erreichen. Der Vertrieb meldet sich bei Ihnen.</p>${leadForm("vertrieb")}</div><div class="result">${A.termin ? `<p style="font-size:var(--s-1);font-weight:600">Lieber gleich einen Termin?</p><a class="btn btn--red" href="${esc(A.termin)}">Termin direkt buchen <span class="arr">→</span></a>` : ""}${callBlock("vertrieb")}</div>`;
  if (id === "r_projekt") {
    const big = A.groesse === "50–249" || A.groesse === "250+";
    return `<div class="result"><h3>Passt. Ihr Gespräch mit dem Vertrieb.</h3><dl>${summaryRows()}</dl><p style="font-size:var(--s-1);color:var(--fg-2)">${big ? "Bei Ihrer Größe kommt gern jemand für ein erstes Gespräch zu Ihnen." : "Meist reichen 20 Minuten am Telefon, um zu sehen, ob und wie wir helfen können."}</p>${leadForm("vertrieb")}</div><div class="result"><p style="font-size:var(--s-1);font-weight:600">Lieber gleich einen Termin?</p><button class="btn btn--red" type="button" data-termin-open="erstgespraech">Erstgespräch direkt buchen <span class="arr">→</span></button>${callBlock("vertrieb")}<p style="font-size:var(--s-1)"><button class="copy" type="button" data-copy-mail>Anfragetext kopieren</button></p></div>`;
  }
  if (id === "r_bewerbung") {
    const st = DATA.stellen.find((s) => s.titel === A.stelle);
    return `<div class="result"><h3>Gute Wahl.</h3><p style="font-size:var(--s-1)">Alle Details zur Stelle und die Online-Bewerbung findest Du in unserem Bewerberportal. Das dauert nur ein paar Minuten.</p><div class="row"><a class="btn btn--red" href="${(st && st.url) || DATA.bewerbung.portal}" target="_blank" rel="noopener">Ausführliche Beschreibung und Online-Bewerbung <span class="arr">→</span></a></div></div><div class="result"><p style="font-size:var(--s-1);font-weight:600">Deine Ansprechpartner</p><div class="bw-personen">${DATA.bewerbung.personen.map((p) => `<div class="bw-person">${p.bild ? `<img src="${p.bild}" alt="" style="object-position:${p.fokus}">` : ""}<b>${esc(p.name)}</b><span>${esc(p.rolle)}</span></div>`).join("")}</div><p style="font-size:var(--s-1)">Fragen vorab oder lieber klassisch? Schreib uns an <a href="mailto:${DATA.bewerbung.mail}">${DATA.bewerbung.mail}</a>.</p></div>`;
  }
  if (id === "r_termin_technik") return `<div class="result"><h3>Das kommt bald.</h3><p style="font-size:var(--s-1)">${esc(DATA.terminTechnik)}</p><div class="row"><button class="btn btn--red" type="button" data-open="stoerung">Ticket öffnen</button></div>${callBlock("support")}</div><div class="result"><p style="font-size:var(--s-1)">Geht es doch um ein neues Projekt? Dann sprechen Sie mit dem Vertrieb.</p><button class="btn" type="button" data-termin-open="erstgespraech">Erstgespräch mit dem Vertrieb buchen <span class="arr">→</span></button></div>`;
  // Benutzer- und Rechteänderungen laufen über die Formulare im Cockpit (Kundenportal)
  if (id === "r_cockpit") return `<div class="result"><h3>Das geht am schnellsten im Cockpit.</h3><p style="font-size:var(--s-1)">Für neue Benutzer, Änderungen und Rechte gibt es im Kundenportal fertige Formulare. So kommen alle Angaben vollständig bei uns an, und Sie sehen jederzeit, wie weit Ihr Auftrag ist.</p><div class="row"><a class="btn btn--red" href="${L.portal}" target="_blank" rel="noopener">Zum Cockpit <span class="arr">→</span></a></div></div><div class="result"><p style="font-size:var(--s-1)">Noch keinen Zugang zum Cockpit? Wir richten ihn ein.</p>${callBlock("support")}</div>`;
  if (id === "r_auftrag") {
    return `<div class="result"><h3>Wir legen ein Ticket für Ihren Auftrag an.</h3><dl>${summaryRows()}</dl>${leadForm("auftrag")}</div><div class="result"><p style="font-size:var(--s-1)">Lieber im Kundenportal?</p><div class="row"><a class="btn" href="${L.portal}" target="_blank" rel="noopener">Kundenportal</a></div>${callBlock("support")}</div>`;
  }
  if (id === "r_erweiterung") return `<div class="result"><h3>Das klärt Ihr Vertrieb.</h3><dl>${summaryRows()}</dl><p style="font-size:var(--s-1);color:var(--fg-2)">Ob neue Arbeitsplätze, zusätzliche Lizenzen oder Ersatz für alte Hardware: Sagen Sie uns kurz, worum es geht. Wir melden uns mit einem Vorschlag.</p>${leadForm("vertrieb")}</div><div class="result">${callBlock("vertrieb")}</div>`;
  if (id === "r_vertrag") return `<div class="result"><h3>Rechnungen und Lizenzen finden Sie im Cockpit.</h3><p style="font-size:var(--s-1)">Rechnungskopien und eine aktuelle Lizenzübersicht liegen jederzeit im Kundenportal bereit.</p><div class="row"><a class="btn btn--red" href="${L.portal}" target="_blank" rel="noopener">Zum Cockpit <span class="arr">→</span></a></div></div><div class="result"><h3>Etwas anderes zu Vertrag oder Lizenzen?</h3><p style="font-size:var(--s-1);color:var(--fg-2)">Schreiben Sie uns kurz, worum es geht. Ihr Ansprechpartner im Vertrieb meldet sich.</p>${leadForm("vertrieb")}</div>`;
  if (id === "r_infos") return `<div class="result"><h3>Informiert bleiben.</h3><p style="font-size:var(--s-1);color:var(--fg-2)">Wählen Sie, was Sie per Mail bekommen möchten. Sie können sich jederzeit über den Link in jeder Mail wieder abmelden.</p>${infoForm()}</div>`;
  if (id === "r_sonst") return `<div class="result"><h3>Die Zentrale hilft weiter.</h3>${callBlock("zentrale")}<p style="font-size:var(--s-1)">${DATA.adresse}</p>${leadForm("allgemein")}</div>`;
  return "";
}

/* Draw existing portrait artwork once per size, without per-letter DOM nodes. */
(function () {
  const canvases = $$("canvas[data-pixel-runs]");
  if (!canvases.length) return;
  const ready = document.fonts ? document.fonts.ready : Promise.resolve();
  ready.then(() => canvases.forEach((canvas) => {
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    let runs;
    runs = canvas.dataset.pixelRuns.split("|").map((run) => [Number(run[0]), run.slice(1)]);
    if (runs.some(([level]) => !Number.isInteger(level) || level < 0 || level > 4)) return;
    const draw = () => {
      const width = canvas.clientWidth, height = canvas.clientHeight;
      if (!width || !height) return;
      const ratio = Math.min(window.devicePixelRatio || 1, 3);
      canvas.width = Math.round(width * ratio); canvas.height = Math.round(height * ratio);
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      const size = width / 30;
      ctx.font = `600 ${size}px ${getComputedStyle(canvas).getPropertyValue("--mono")}`;
      const step = ctx.measureText("M").width;
      const metrics = ctx.measureText("Mg");
      const ascent = metrics.fontBoundingBoxAscent ?? size * .8;
      const descent = metrics.fontBoundingBoxDescent ?? size * .2;
      const baseline = (size * .75 - ascent - descent) / 2 + ascent;
      let x = 0, row = 0;
      runs.forEach(([level, text]) => {
        ctx.globalAlpha = [0, .22, .45, .72, 1][level] ?? 0;
        ctx.fillStyle = level === 4 ? "#fff" : "#F2F1F4";
        ctx.shadowColor = "rgb(255 255 255 / .35)";
        ctx.shadowBlur = level === 4 ? 6 * ratio : 0;
        for (const letter of text) {
          if (letter === "\n") { x = 0; row++; continue; }
          if (level && letter !== " ") ctx.fillText(letter, x * step, row * size * .75 + baseline);
          x++;
        }
      });
      canvas.parentElement.classList.add("is-drawn");
    };
    draw();
    if ("ResizeObserver" in window) new ResizeObserver(draw).observe(canvas);
    else window.addEventListener("resize", draw);
  }));
})();

/* ---------- Teamkarten „Pixelmenschen“: ohne Hover (Touch) erscheint das Foto, sobald die Karte mittig im Bild steht ---------- */
(function () {
  const karten = $$(".tm--pixel");
  if (!karten.length || !matchMedia("(hover: none)").matches || !("IntersectionObserver" in window)) return;
  const io = new IntersectionObserver((es) => es.forEach((e) => e.target.classList.toggle("zeigt", e.isIntersecting)), { rootMargin: "-35% 0px -35% 0px" });
  karten.forEach((k) => io.observe(k));
})();

/* ---------- Links in neuem Fenster ansagen ---------- */
function markExternal(root) {
  $$('a[target="_blank"]', root).forEach((a) => { if (a.dataset.ext) return; a.dataset.ext = 1; const s = document.createElement("span"); s.className = "sr-only"; s.textContent = " (öffnet in neuem Fenster)"; a.appendChild(s); });
}
markExternal(document);
new MutationObserver(() => markExternal($("#chat"))).observe($("#chat"), { childList: true, subtree: true });

})();
